import { clearTimeouts, engine as anime } from "../../../../../animations";
import { getTemplateDurationOveride } from "../../../../shared/utils/timeline"

const timeouts = [];

const main = (props) => {
    const timeouts = [];
    const { id, format, templateName, data } = props;

    const templateDuration = getTemplateDurationOveride({
        apiSetup: props?.apiSetup,
        tournamentId: props?.data?.event?.competitionId,
        fallback:
            _.find(props?.data?.data?.options, { id: "videoduration" })?.value || 0,
        templateName,
        event: data?.event
    });
    $(`#${id} .ant-progress-bg`).css("width", "100%");
    $(`#${id} .ant-progress-bg`).css(
        "transition-duration",
        `${templateDuration}s`,
    );

    const timeline = anime.timeline();
    anime({
        targets: [`#${id} .qatar-logo`],
        duration: 800,
        easing: "easeOutQuint",
        scale: [0, 1],
        opacity: [1, 1],
        delay: 200,
    });

    anime({
        targets: [`#${id} .versus-info`],
        duration: 800,
        easing: "easeOutQuint",
        translateX: [-2000, 0],
        opacity: [1, 1],
        delay: 400,
    });

    anime({
        targets: [`#${id} .comp-match-score-widget`],
        duration: 800,
        easing: "easeOutQuint",
        translateX: [-2000, 0],
        opacity: [1, 1],
        delay: 500,
    });

    anime({
        targets: [`#${id} .wc-headline`],
        duration: 800,
        easing: "easeOutQuint",
        opacity: [0, 1],
        delay: 400,
    });

    anime({
        targets: [`#${id} .pitch-container`],
        duration: 800,
        easing: "easeOutQuint",
        translateX: [2000, 0],
        opacity: [1, 1],
        delay: 700,
    });

    anime({
        targets: [`#${id} .team-logo-container`],
        duration: 800,
        easing: "easeOutQuint",
        translateX: [-2000, 0],
        opacity: [1, 1],
        delay: 600,
    });

    anime({
        targets: [`#${id} .coach-info`],
        duration: 800,
        easing: "easeOutQuint",
        translateX: [-2000, 0],
        opacity: [1, 1],
        delay: 800,
    });

    const timeout1 = setTimeout(() => {
        anime({
            targets: [`#${id} .lineup`],
            duration: 800,
            easing: "easeOutQuint",
            translateX: [2000, 0],
            opacity: [1, 1],
            delay: anime.stagger(300),
        });
    }, 400);

    const timeout2 = setTimeout(() => {
        const $targetContainer = $(`#${id} .lineup-reserve .lineup-content`);
        const visibleHeight = $(
            `#${id} .lineup-reserve`,
        ).outerHeight();;
        const contentHeight = $targetContainer.outerHeight();
        const heightOutOfView = contentHeight - visibleHeight;

        if (heightOutOfView > 0) {
            anime({
                targets: [`#${id} .lineup-reserve .lineup-content`],
                duration: 4000,
                easing: "easeInOutQuad",
                top: [0, -heightOutOfView - 1],
                // rotateZ: [22, 22],
                opacity: [1, 1],
                delay: 0,
            });
        }
    }, 2000);

    const timeout3 = setTimeout(() => {
        anime({
            targets: [`#${id} .heatmap-pitch`],
            duration: 500,
            easing: "easeInOutQuad",
            opacity: [0, 1],
            delay: 0,
        });

        anime({
            targets: [`#${id} .lineup`],
            duration: 800,
            easing: "easeOutQuint",
            opacity: [1, 0],
            delay: anime.stagger(300),
        });

        anime({
            targets: [`#${id} .lineup-tactics-player`],
            duration: 500,
            easing: "easeOutQuint",
            // translateX: [2000, 0],
            opacity: [0, 1],
            scale: [0, 1],
            delay: anime.stagger(80),
        });
    }, 6500);

    timeouts.push(timeout1);
    timeouts.push(timeout2);
    timeouts.push(timeout3);

    return {
        timeline: [],
        timeouts,
    };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
    const { timeouts } = animationReturn;
    clearTimeouts(timeouts);
};

export default main;
